import { Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import '../waterOilTable/waterOilTable.css';
import { GenerateColumns, getGasOilData } from './utils';
import { AnalyzeType } from '../../../@types/samples/types';
import { Zone } from '../../../@types/projects/types';

const GasOilTable = ({ showScaledKr, analysisType, zones }: { showScaledKr: boolean; analysisType: AnalyzeType; zones: Zone[] }) => {
  const [showTable, setShowTable] = useState(true);

  const data = getGasOilData(zones, analysisType, showScaledKr);
  const columns = GenerateColumns(zones, showScaledKr);

  return (
    <div style={{ marginTop: '2rem' }}>
      <div style={{ display: 'flex' }}>
        <p style={{ fontWeight: 'bold', fontSize: '18px' }}>
          Gas-Oil System Saturation Functions
        </p>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => setShowTable(!showTable)}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              fontSize: '1.3rem',
              marginTop: '0.3rem',
              marginLeft: '1rem',
              transform: `rotate(${showTable ? '0deg' : '180deg'})`,
              transition: 'transform 0.4s ease'
            }}
          />
        </div>
      </div>
      <div
        className={`water-oil-table-container ${showTable ? 'expanded' : 'collapsed'}`}
      >
        <Table
          dataSource={data}
          columns={columns}
          scroll={{ x: 1500, y: 500 }}
          pagination={false}
          bordered
          size="small"
        />
      </div>
    </div>
  );
};

export default GasOilTable;
